import React from 'react';
import { useNavigate  } from 'react-router-dom';

const SliderCard = ({ data }) => {
    const navigate = useNavigate(); 
    const { mid, heading, tag, bg, title, last, ptag, ptag01, ptag1, ptag2, ptag3, ptag4 } = data;

    return (
        <div
            className="slide"
            style={{
                backgroundImage: `
            linear-gradient(
              90deg,
              rgba(255, 255, 255, 1) 0%,
              rgba(200, 209, 203, 0) 93%
            ),
            url(${bg})
          `,
                backgroundSize: "cover",
                backgroundPosition: "center",
            }}
        >
            <div className="container">
                <div className="row clearfix">
                    {/* <!-- Content Column --> */}
                    <div className="content-column col-xl-7 col-lg-7 col-md-10 col-sm-12">
                        <div className="inner-column">
                            <div className="title">{title}</div>
                            <h1>{heading}  <span>{tag}</span>{last}</h1>

                            {/* <h1>{heading} <br /> {mid} <span>{tag}</span>{last}</h1> */}
                            {/* <p>{ptag}</p> */}
                            {/* <p>{ptag01}</p>
                            <p>{ptag1}</p>
                            <p>{ptag2}</p>
                            <p>{ptag3}</p>
                            <p>{ptag4}</p> */}

                            <ul className="custom-points">
                                {[ptag01, ptag1, ptag2, ptag3, ptag4]
                                    .filter(Boolean)
                                    .map((point, index) => (
                                        <li key={index} style={{
                                            fontSize: "18px",   // increase size here
                                            lineHeight: "1.6",
                                            marginBottom: "8px"
                                        }}>{point}</li>
                                    ))}
                            </ul>




                            <div className="text">Stusphere is a  full-service consultation firm with record of winning many <br /> successful campaigns. Have a great journey with us</div>
                            <div className="options-box">
                                {/* <!-- Button Box --> */}
                                <div className="button-box d-flex flex-wrap">
                                    <a href="#" className="btn">
                                        <span className="btn-wrap">
                                            <span className="text-one">Learn More</span>
                                            <span className="text-two">Learn More</span>
                                        </span>
                                    </a>
                                    <a className="btn btn-three"  onClick={() => navigate("/contact#Contact-form")}>
                                        <span className="btn-wrap">
                                            <span className="text-one">Get Service</span>
                                            <span className="text-two">Get Service</span>
                                        </span>
                                    </a>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default SliderCard;